import LayoutConstants from '@/constansts/layoutConstants';
import { SETTINGS_ROUTE_NAME } from '@/modules/settings/constants/settingsConstants';
import {
  buildPlatformDesktopAccountMenuItemsFromRows,
  buildPlatformDesktopAccountRows,
} from './platformDesktopAccountNav';

export const getUserProfileDetails = (staffData, attributes) => ({
  imagePath: staffData?.photo_path || attributes?.photo_path || '',
  email: staffData?.email || '',
  displayName: staffData?.display_name || '',
  colorId: staffData?.color_id || 27,
});

const filterAccountMenuByAccess = (items, { hasRolesAndPermissions, hasPermission, staffRole }) => {
  if (hasRolesAndPermissions) {
    return items.filter((item) => (item.permission ? hasPermission(item.permission) : true));
  }
  const role = staffRole || '';
  return items.filter((item) => item.roles.includes(role));
};

const buildLegacyBaseAccountItems = ({
  t, myAccountMenuWideFF, newProfilePageFF, povSettingsPageFF = false,
}) => {
  const myAccountRoute = myAccountMenuWideFF ? 'app.setting_menu' : 'app.settings_page';
  const profileRoute = newProfilePageFF ? 'staffProfile' : 'app.business_info_settings';
  const profileRouteType = newProfilePageFF
    ? LayoutConstants.ROUTING_TYPES.pov
    : LayoutConstants.ROUTING_TYPES.angular;
  const settingsPermission = newProfilePageFF ? null : 'can_access_settings';

  return [
    {
      label: t('common.navigation.account'),
      icon: 'icon-user',
      event: 'my-account',
      roles: ['admin', 'manager', 'marketing'],
      permission: 'can_access_settings',
      routingType: LayoutConstants.ROUTING_TYPES.angular,
      route: myAccountRoute,
      routeData: { page: 'my_account' },
    },
    {
      label: t('common.navigation.profile'),
      icon: 'icon-Suitcase',
      event: 'business-info',
      roles: ['admin', 'manager', 'marketing'],
      permission: 'can_access_settings',
      routingType: profileRouteType,
      route: profileRoute,
    },
    {
      label: t('common.navigation.settings'),
      icon: 'icon-Settings',
      event: 'settings',
      roles: ['admin', 'manager', 'marketing'],
      permission: settingsPermission,
      routingType: povSettingsPageFF ? LayoutConstants.ROUTING_TYPES.pov : LayoutConstants.ROUTING_TYPES.angular,
      route: povSettingsPageFF ? SETTINGS_ROUTE_NAME : 'app.settings',
      routeData: {},
    },
    {
      label: t('common.navigation.staff'),
      icon: 'icon-User-vneck',
      event: 'staff',
      roles: ['admin'],
      permission: 'can_access_staff_management',
      routingType: LayoutConstants.ROUTING_TYPES.angular,
      route: 'app.settings_page',
      routeData: { page: 'staff' },
    },
  ];
};

export const buildAccountMenuItems = ({
  t,
  myAccountMenuWideFF,
  newProfilePageFF,
  povSettingsPageFF = false,
  hasGettingStartedDeny,
  hasRolesAndPermissions,
  hasPermission,
  staffRole,
}) => {
  const items = buildLegacyBaseAccountItems({
    t, myAccountMenuWideFF, newProfilePageFF, povSettingsPageFF,
  });

  if (!hasGettingStartedDeny) {
    items.push({
      label: t('onboarding.new_onboarding.quick_btn_title'),
      icon: 'icon-Rocket_new',
      event: 'getting-started',
      roles: ['admin'],
      permission: 'can_access_admin_account',
      action: 'openChecklist',
    });
  }

  return filterAccountMenuByAccess(items, { hasRolesAndPermissions, hasPermission, staffRole });
};

export const buildPlatformNavigationDesktopAccountMenuItems = ({
  t,
  myAccountMenuWideFF,
  newProfilePageFF,
  hasGettingStartedDeny,
  hasRolesAndPermissions,
  hasPermission,
  staffRole,
}) => {
  const rows = buildPlatformDesktopAccountRows({
    myAccountMenuWideFF,
    newProfilePageFF,
    hasGettingStartedDeny,
    hasRolesAndPermissions,
  });
  const items = buildPlatformDesktopAccountMenuItemsFromRows(rows, t);
  return filterAccountMenuByAccess(items, { hasRolesAndPermissions, hasPermission, staffRole });
};

export const buildPlatformMobileProfilePanelItems = ({
  t,
  hasFeature,
  hasPermission,
  staffRole,
}) => {
  const items = [];
  const isNewProfilePageEnabled = hasFeature('new_profile_page');

  items.push({
    label: t('common.navigation.profile'),
    icon: 'icon-Suitcase',
    event: 'business-info',
    routingType: isNewProfilePageEnabled
      ? LayoutConstants.ROUTING_TYPES.pov
      : LayoutConstants.ROUTING_TYPES.angular,
    route: isNewProfilePageEnabled ? 'staffProfile' : 'app.business_info_settings',
  });

  const canShowStaff = hasFeature('roles_and_permissions')
    ? hasPermission('can_access_staff_management')
    : staffRole === 'admin';

  if (canShowStaff) {
    items.push({
      label: t('common.navigation.staff'),
      icon: 'icon-User-vneck',
      event: 'staff',
      routingType: LayoutConstants.ROUTING_TYPES.angular,
      route: 'app.settings_page',
      routeData: { page: 'staff' },
    });
  }

  if (hasFeature('roles_and_permissions') && hasPermission('can_access_settings')) {
    items.push({
      label: t('common.navigation.role_permissions'),
      icon: 'icon-Lock2',
      event: 'roles-and-permissions',
      routingType: LayoutConstants.ROUTING_TYPES.pov,
      route: 'RolesListPage',
    });
  }

  return items;
};
